import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable, of } from 'rxjs';
import { CommonService } from '../common/common.service';
import { TshqRequestOptions } from '@app/core/Models';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class SubmitService {

  constructor(private http: HttpClient, private commonService: CommonService) {}

  checkPrevalidationErrors(id: any, periodId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}AnnualReport/checkPrevalidationErrors?reportId=${id}&accountingPeriodId=${periodId}`);
  }

  previewHtmlReportFile(id: any, periodId:any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    
    return this.http.post<any>(`${environment.apiVersionUrl}AnnualReport/previewHtmlReportFile/${periodId}/${id}`, id,headers);
  }

  getGatewayDetails(submitId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}AnnualReport/GetGatewayDetails?Submitid=${submitId}`);
  }

  getSubmitAccountDetails(reportId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}AnnualReport/GetSubmitAccountDetails?AccountingPeriodId=${reportId}`);
  }

  submitReport(reportDetails: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(`${environment.apiVersionUrl}AnnualReport/submitReport`, this.commonService.trimObjectSpace(JSON.stringify(reportDetails)), headers);
  }

  getSubmitMainGridDetails(accountingPeriodId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiVersionUrl}AnnualReport/GetSubmitMainGridDetails?AccountingPeriodId=${accountingPeriodId}`);
  }

  submitReportDownloadHTML(id: any, periodId: any):any {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.postExportRequest(`${environment.apiVersionUrl}AnnualReport/submitReportDownloadPDF/${periodId}/${id}`,id, headers).pipe(
      switchMap((response:any) => {
        const body: Blob = response.body || new Blob();
        this.download(response);
        
        return of(true);
      })
    );
  }

  submitReportDownloadPDF(submitId: any, periodId: any):any {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.postExportRequest(`${environment.apiVersionUrl}AnnualReport/submitResponseDownloadPDF?SubmitId=${submitId}&AccountingPeriodid=${periodId}`,submitId, headers).pipe(
      switchMap((response:any) => {
        const body: Blob = response.body || new Blob();
        this.download(response);
        
        return of(true);
      })
    );
  }

  postExportRequest(
    endpoint: string,
    params?: any | null,
    options?: TshqRequestOptions
  ): Observable<HttpResponse<Blob>> {
    return this.http.post(endpoint, params, {
      ...options,
      responseType: 'blob',
      observe: 'response',
    });
  }

  download(response: HttpResponse<Blob>): void {
    let fileName = response.headers
      .get('Content-Disposition')
      ?.split(';')
      .map((x) => (x ?? '').trimLeft().split('='))
      .find((x) => x[0] === 'filename')
      ?.pop();

    const a = document.createElement('a');
    let navigator: any;
    navigator = window.navigator;

    if (fileName !== undefined && fileName !== null) {
      fileName = fileName.replace(/"/g, '');
    }

    if (navigator && navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(response, fileName);
    } else {
      a.href = URL.createObjectURL(response.body || new Blob());
      a.download = fileName ?? '';
      a.click();
    }
  }

  deleteSubmittedFile(submitId: Guid): Observable<any> {
    return this.http.delete<any>(`${environment.apiVersionUrl}AnnualReport/deleteSubmittedFile?SubmitId=${submitId}`);
  } 
  getMessageDetail(submitId: any): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get<any>(`${environment.apiVersionUrl}AnnualReport/GetSubmissionStatus?SubmitID=${submitId}`);
  }
}
